/**
 * ============================================================================
 * APP PROVIDER - Main Provider
 * ============================================================================
 * 
 * Wraps all providers in the correct order
 */

import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import ThemeProvider from './ThemeProvider';
import AuthProvider from './AuthProvider';
import APIProvider from './APIProvider';
import ToastProvider from './ToastProvider';
import ModalProvider from './ModalProvider';
import QueryProvider from './QueryProvider';
import I18nProvider from './I18nProvider';
import AnalyticsProvider from './AnalyticsProvider';

/**
 * App Provider Component
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {Object} props.config - Configuration options
 * @param {Object} props.modals - Custom modal components
 * @returns {JSX.Element}
 */
export const AppProvider = ({ children, config = {}, modals = {} }) => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <I18nProvider defaultLocale={config.defaultLocale || 'en'}>
          <APIProvider>
            <AuthProvider>
              <QueryProvider>
                <AnalyticsProvider config={config.analytics || {}}>
                  <ToastProvider>
                    <ModalProvider modals={modals}>
                      {children}
                    </ModalProvider>
                  </ToastProvider>
                </AnalyticsProvider>
              </QueryProvider>
            </AuthProvider>
          </APIProvider>
        </I18nProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default AppProvider;
